var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelogio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.358,
    height: 105.359,
    viewBox: "0 0 110.358 105.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12212",
    "data-name": "Grupo 12212",
    transform: "translate(-633.642 -335.641)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_877",
    "data-name": "Elipse 877",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(646 343)",
    fill: "#c9ddef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12211",
    "data-name": "Grupo 12211",
    transform: "translate(331.737 134.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17080",
    "data-name": "Caminho 17080",
    d: "M351.265,201.218a49.358,49.358,0,1,0,49.357,49.357A49.413,49.413,0,0,0,351.265,201.218Zm0,92.623a43.265,43.265,0,1,1,43.264-43.266A43.315,43.315,0,0,1,351.265,293.841Z",
    fill: "#004f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17081",
    "data-name": "Caminho 17081",
    d: "M327,231.759v-15.28a3.047,3.047,0,1,0-6.093,0v16.54l0,.012a3.073,3.073,0,0,0,.89,2.145l20.671,20.676a3.047,3.047,0,1,0,4.309-4.309Z",
    transform: "translate(27.312 17.556)",
    fill: "#004f92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelogio);
export default __webpack_public_path__ + "static/media/relogio.a0b0d0ff46ad02b12ba6cbab207b6d35.svg";
export { ForwardRef as ReactComponent };